/**
 * 收藏单
 */
import React, { FC, useEffect } from 'react'
import { observer } from 'mobx-react'
import { favoMobx, mallMobx, productMobx } from 'mobx/mall'
import { decorationMobx } from '@mobxStore'
import { IonContent, IonPage, useIonViewDidEnter, useIonViewWillEnter } from '@ionic/react'
import { FavFooter, ProductItems } from './component'
import { setDocumentTitle, useHistoryNew } from '@utils'
import './index.scss'

interface IProps { }

const Favorite: FC<IProps> = ({ }) => {
  const history = useHistoryNew()
  const { mallGlobalDecorates: { collect } } = decorationMobx
  useIonViewWillEnter(async () => {
    if (!mallMobx.isInited) {
      mallMobx.init()
    }
  }, [history])
  return (
    <IonPage className='favorite-page'>
      <IonContent>
        <ProductItems />
      </IonContent>
      {favoMobx.productList.length > 0 && <FavFooter />}
    </IonPage>
  )
}

export default observer(Favorite)
